import Model from './model';

export default class Title extends Model {
  static NAME = 'title';
  static COLLECTION_NAME = "titles";
  static URL = '/api/v2/titles';

  static SUGGESTIONS = [
    'IT Support Specialist',
    'Cloud Specialist',
    'Cyber Security Specialist',
    'Database Administrator',
    'DevOps Engineer',
    'Network Administrator',
    'Software Developer',
    'Project Manager',
    'Product Manager',
    'Business Analyst',
    'Digital Marketing Specialist',
    'Content Writer',
    'Social Media Specialist',
    'SEO Specialist',
    'Legal Assistant',
    'Financial Analyst',
    'Accountant',
    'Operations Manager',
    'Recruitment Specialist',
    'Human Resource Manager',
    'Customer Success Representative',
  ]
}
